module.exports = __webpack_public_path__ + "img/vertical_7_6_9005.e9096912.png";